import React, { useEffect, useState } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import useAuth from '../../context/auth/useAuth'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { getClubsByUser } from '../../actions/profiles/clubsActions'
import { jwtDecode } from 'jwt-decode'
import Loader from '../../components/design/Loader/Loader'

export default function Lobby({handleClubSelect}) {
    const { t } = useTranslation()
    const dispatch = useDispatch()
	const {clientauth} = useAuth()
    const tokensave = sessionStorage.getItem('jwt')

    const {clubs,loadingclub} = useSelector(state=>state.clubs)

    const [token, setToken] = useState()

    useEffect(() =>{
        if(tokensave){
            setToken(jwtDecode(tokensave))
        }
    }, [tokensave])

    useEffect(() =>{
        if(token && clientauth){
            dispatch(getClubsByUser(clientauth?.id))
        }
    }, [token, dispatch, clientauth])

    return (
        <Container className='cuerpo'>
            <div className='welcome-banner'>
                <div className='welcome-content'>
                    <h1 className='welcome-title'>{t('lobby.dashboard.welcome')}</h1>
                    <p className='welcome-subtitle'>{t('lobby.dashboard.subwelcome')}</p>
                </div>
                <div className='welcome-icon'>
                    <i className="fas fa-futbol"></i>
                </div>
            </div>

            <div className='section-title'>
                <h2>{t('lobby.selectClub') || 'Selecciona un club'}</h2>
            </div>
            <Row className="g-4">
                { loadingclub
                ?
                    <Col><Loader/></Col>
                :
                    clubs?.map((club, index) => (
                    <Col xs={12} sm={6} lg={4} key={index}>
                        <div className='club-card' onClick={() => handleClubSelect(club._id)}>
                            <Link to={`/${t("url.club.club")}/${t("url.club.dashboard")}`} className="text-decoration-none">
                                <div className='club-card-header'>
                                    <img
                                        src={club.avatar ? club.avatar : "/images/shield.png"}
                                        alt={club.name}
                                        width={56}
                                        height={56}
                                        className='club-card-avatar'
                                    />
                                    <div className='club-card-info'>
                                        <h3>{club.name}</h3>
                                        <span className='club-card-badge'>
                                            <i className="fas fa-arrow-right"></i>
                                        </span>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </Col>
                    ))
                }
            </Row>
        </Container>
    )
}
